// document-opener.js
/* global moment */

const BASE_URL = process.env.VUE_APP_APP_URL

export function openDocument (path) {
  const url = `${BASE_URL}${path}?${moment().unix()}`
  window.open(url)
}

export function openCovidDoc (lang) {
  const upperLang = lang.toUpperCase()
  openDocument(`documents/MICFootball2022-COVID_${upperLang}.pdf`)
}

export function openSimpleDoc (filename) {
  openDocument(`documents/${filename}`)
}

export function openCategoryDoc (category) {
  const cleaned = category.toUpperCase().replace(/ /g, '').replace(/-/g, '')
  openDocument(`documents/${cleaned}.pdf`)
}

export function openMyTeams (teamId, eventId, token, lang) {
  const url =
    `https://api.micsports.es/team/${teamId}/event/${eventId}/myteams` +
    `?authorization=${token}&lang=${lang}`
  window.open(url)
}

export function openStaticExternalDoc (path) {
  const url = `https://api.micsports.es/static/document/${path}?${moment().valueOf()}`
  window.open(url)
}
